import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import AppointmentRequest from './icons/AppointmentRequest';
import Balance from './icons/Balance';
import Electrick from './icons/Electrick';
import Mail from './icons/Mail';
import ManageAvailability from './icons/ManageAvailability';
import ReminderEmail from './icons/ReminderEmail';
import ShareLink from './icons/ShareLink';
import World from './icons/World';
import UltimateFeaturesItems from './UltimateFeaturesItems';

var UltimateFearures = function UltimateFearures() {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var features = [{
    name: 'landing.features.availabilitiesHandling',
    description: 'landing.features.availabilitiesHandlingDesc',
    icon: /*#__PURE__*/_jsx(World, {
      className: "w-6 h-6 text-gray-300"
    }),
    image: /*#__PURE__*/_jsx(ManageAvailability, {
      className: "w-4/5 h-4/5"
    }),
    left: true
  }, {
    name: 'landing.features.shareLinkToCustomersAndAttendees',
    description: 'landing.features.shareLinkToCustomersAndAttendeesDesc',
    icon: /*#__PURE__*/_jsx(Balance, {
      className: "w-6 h-6 text-gray-300"
    }),
    image: /*#__PURE__*/_jsx(ShareLink, {
      className: "w-4/5 h-4/5"
    }),
    left: false
  }, {
    name: 'landing.features.bookAppointment',
    description: 'landing.features.bookAppointmentDesc',
    icon: /*#__PURE__*/_jsx(Electrick, {
      className: "w-6 h-6 text-gray-300"
    }),
    image: /*#__PURE__*/_jsx(AppointmentRequest, {
      className: "w-4/5 h-4/5"
    }),
    left: true
  }, {
    name: 'landing.features.reminderEmail',
    description: 'landing.features.reminderEmailDesc',
    icon: /*#__PURE__*/_jsx(Mail, {
      className: "w-6 h-6 text-gray-300"
    }),
    image: /*#__PURE__*/_jsx(ReminderEmail, {
      className: "w-4/5 h-4/5"
    }),
    left: false
  }];
  return /*#__PURE__*/_jsxs("section", {
    id: "features",
    className: "px-2 py-8 bg-gray-100 border-b lg:px-8",
    children: [/*#__PURE__*/_jsx("h2", {
      className: "w-full my-2 text-3xl font-black leading-tight text-center text-gray-800 lg:text-5xl",
      children: t('landing.navigations.features')
    }), /*#__PURE__*/_jsx("div", {
      className: "w-full mb-2",
      children: /*#__PURE__*/_jsx("div", {
        className: "w-64 h-1 py-0 mx-auto my-0 rounded-t opacity-25 gradient"
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: "mt-2 text-center",
      children: [/*#__PURE__*/_jsx("h3", {
        className: "text-2xl font-black text-gray-600",
        children: t('landing.features.featureStepTitle')
      }), /*#__PURE__*/_jsx("p", {
        className: "max-w-4xl mx-auto mt-3 mb-8 text-base text-gray-500 sm:mt-5 sm:text-xl",
        children: t('landing.features.featureStepDescription')
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "container mx-auto mt-16 max-w-7xl",
      children: /*#__PURE__*/_jsx(UltimateFeaturesItems, {
        features: features
      })
    })]
  });
};

export default UltimateFearures;